/*global document, window */

(function () {
  'use strict';

  var dialog = null;

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'energy-label-dialog';
    dialog.innerHTML =
      '<div class="energy-label-dialog__inner">' +
        '<p class="energy-label-dialog__title strong"></p>' +
        '<button type="button" class="energy-label-dialog__close">' +
          '<i aria-hidden="true" class="icon-x-circle"></i>' +
        '</button>' +
        '<img class="energy-label-dialog__image" src="" alt="" loading="lazy">' +
      '</div>';

    dialog.querySelector('.energy-label-dialog__close').addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (!target || typeof target.closest !== 'function') {
      return;
    }

    var trigger = target.closest('[data-energy-label-png]');

    if (!trigger) {
      return;
    }

    var source = trigger.getAttribute('data-energy-label-png');

    if (!source) {
      return;
    }

    event.preventDefault();

    var popup = dialog || buildDialog();
    var title = trigger.getAttribute('data-energy-label-title') || '';
    var image = popup.querySelector('.energy-label-dialog__image');

    popup.querySelector('.energy-label-dialog__title').textContent = title;
    popup.querySelector('.energy-label-dialog__close').setAttribute(
      'aria-label',
      trigger.getAttribute('data-energy-label-close') || 'Close'
    );
    image.setAttribute('src', source);
    image.setAttribute('alt', title);

    if (typeof popup.showModal === 'function') {
      popup.showModal();
    } else {
      window.open(source, '_blank', 'noopener');
    }
  });
})();
